import { BillingCycle } from '@/common/types/organisation';

const BASE_URL = 'https://hooks.zapier.com/hooks/catch/19806648';

const ZapierHookId = {
  error: '2amnk11',
  onboarding: '260rsiv',
  subscription: 'u372ibt',
  feedback: 'ugdigpj',
} as const;

interface BaseZapierPayload {
  hook: keyof typeof ZapierHookId;
  userId: string;
  organisationId: string;
}

type ErrorPayload = BaseZapierPayload & {
  hook: 'error';
  notifier: string;
  fatal: boolean;
  error: string;
  context?: string;
};

type OnboardingPayload = BaseZapierPayload & {
  hook: 'onboarding';
  organisationName: string;
  name: string;
  email: string;
  role: string;
  referrer: string;
  numStudents: string;
  marketingOptIn: boolean;
};

type SubscriptionPayload = BaseZapierPayload & {
  hook: 'subscription';
  name: string;
  email: string;
  organisationName: string;
} & (
    | {
        event: 'Invoice Payment Confirmed' | 'Card Payment Confirmed';
        plan: string;
        seatCount: number;
        billingCycle: BillingCycle;
        currency: string;
        coupon: string;
        total: string;
      }
    | {
        event: 'Subscription Cancelled';
        cancelAt: string;
      }
  );

type FeedbackPayload = BaseZapierPayload & {
  email: string;
  message: string;
};

export async function notifyZapier(
  payload:
    | ErrorPayload
    | OnboardingPayload
    | SubscriptionPayload
    | FeedbackPayload,
): Promise<void> {
  // if (import.meta.env.MODE === 'development') return;

  const { hook, ...rest } = payload;

  try {
    const response = await fetch(`${BASE_URL}/${ZapierHookId[hook]}`, {
      method: 'POST',
      body: JSON.stringify({
        ...rest,
        url: window.location.href,
        timestamp: new Date().toISOString(),
      }),
    });
    if (!response.ok) {
      console.error('Failed to send error to Zapier', await response.text());
    }
  } catch (error) {
    console.error('Failed to notify Zapier:', error);
  }
}
